<div class="flex flex-col" *ngIf="exportFormHtmlData">
  <div class="m-b-20 flex flex-row justify-start items-start auto-flex">
    <div class="note flex-1-1-100">
      <span>Note:</span> Please follow these instructions to transmit your forms directly with the authority.
    </div>
  </div>
  <div [innerHTML]="exportFormHtmlData | sanitizeHtml" id="from-html-file">

  </div>

</div>

